import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { CheckCircle2 } from "lucide-react";

export default function SuccessCard({ booking, onReset }) {
  return (
    <div
      data-testid="booking-success"
      className="rounded-3xl dark-aurora-radial text-white p-10 md:p-14 paper relative shadow-tactile-lg"
    >
      <div className="relative flex flex-col md:flex-row md:items-start md:justify-between gap-8">
        <div className="max-w-xl">
          <CheckCircle2 size={36} className="text-aurora mb-6" />
          <h3 className="font-display text-3xl md:text-4xl tracking-tight font-medium leading-tight">
            Rendez-vous{" "}
            <em className="not-italic italic font-light text-aurora">
              confirmé.
            </em>
          </h3>
          <p className="text-white/85 mt-5 leading-relaxed text-base md:text-lg">
            Merci {booking.name.split(" ")[0]}. Un email récapitulatif vient de
            partir vers <strong className="text-white">{booking.email}</strong>.
            Je vous recontacterai pour confirmer l'appel du{" "}
            <strong className="text-white">
              {format(new Date(booking.date), "EEEE d MMMM", { locale: fr })}
            </strong>{" "}
            à <strong className="text-white">{booking.time}</strong>.
          </p>
        </div>
        <div className="rounded-2xl bg-white/5 border border-white/15 p-6 text-sm space-y-2 min-w-[220px]">
          <div className="eyebrow !text-aurora">Récapitulatif</div>
          <div className="text-white">{booking.service_label}</div>
          <div className="text-white/70">
            {booking.date} · {booking.time}
          </div>
          <button
            type="button"
            onClick={onReset}
            data-testid="booking-reset-button"
            className="mt-4 text-xs uppercase tracking-[0.18em] text-aurora link-underline font-semibold"
          >
            Nouvelle réservation
          </button>
        </div>
      </div>
    </div>
  );
}
